import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import api from "services/api";
import emailValidate from "services/emailValidate";
import { __ } from "services/Translator";
import ModalCloseButton from "components/ModalCloseButton";

// Password-recovery modal, shared by the login modal (LoginReg) and the PWA
// inline auth screen so both entry points offer the same "forgot password" flow.
export default function RecoverPasswordModal({ show, onHide }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (show) {
      setError("");
      setSent(false);
    }
  }, [show]);

  const submit = async (ev) => {
    ev.preventDefault();
    if (!emailValidate(email)) {
      setError(__("Please enter a valid email address"));
      return;
    }
    const response = await api.post("/request-reset-password", { email });
    if (response.status === 200) {
      setSent(true);
    } else {
      setError(response.data?.message || __("Something went wrong. Please try again."));
    }
  };

  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Body className="login_modal forgot_pass">
        <ModalCloseButton onClick={onHide} className="modal_close_reg" />
        <div className="modal_headline">{__("Password Reset")}</div>
        {!sent && (
          <form onSubmit={submit}>
            <div className="form_area">
              <div className="input_item">
                <label className="name" htmlFor="recover-email">
                  {__("Email")}
                  <span className="requried_icon">*</span>
                </label>
                <input
                  id="recover-email"
                  type="email"
                  name="email"
                  autoComplete="email"
                  placeholder={__("Enter your email")}
                  value={email}
                  onChange={(ev) => setEmail(ev.target.value)}
                  className={" name_value " + (error ? "error" : "")}
                />
                <div className="errorMsg">{error}</div>
              </div>

              <div className="login_button">
                <button type="submit" className="commonBtn pTwoBtn">
                  {__("Send Recover Link")}
                </button>
              </div>
            </div>
          </form>
        )}

        {sent && (
          <p style={{ color: "white" }} className="recovery_success">
            {__("A password recovery email has been sent to your provided email address.")}
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
}
